import React, { useState } from 'react';

import { modalMessages, ids } from 'apps/web_forms/utils/constants';
import Modal from 'apps/web_forms/components/commons/Modal';

export const SubmitFailureModal = ({ extraProps, resetSelectedModal }) => {
  const { fieldErrors } = extraProps;
  const [ isModalOpen, setIsModalOpen ] = useState(true);

  const toggleModalVisibility = (value) => {
    setIsModalOpen(value);
    resetSelectedModal();
  }

  return (
    <Modal
      mainMessage={modalMessages.submitFail.main}
      helpTip={modalMessages.submitFail.tip}
      isOpen={isModalOpen}
      setIsOpen={toggleModalVisibility}
      icon='error'
      testId={ids.FormIds.FormSubmitFailModal}
      children={
        Object.keys(fieldErrors).length === 1 ? (
          <p className='error-field'>{Object.keys(fieldErrors)[0]}</p>
        ) : (
          <p className='error-field'>
            {Object.keys(fieldErrors)[0]} and{' '}
            {Object.keys(fieldErrors).length - 1} other errors.
          </p>
        )
      }
    />
  );
};
